import React, { FC } from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  handleClose(): void;
}

const TFAThirdStep: FC<Props> = ({ handleClose }) => {
  return (
    <div className="modal-container">
      <div className="modal-image">
        <img src="/images/verification-step-3.png" alt="verification-step-3" />
      </div>
      <h2 className="sub-title">
        Success!
      </h2>
      <p className="description-paragraph">
        Your phone number has been verified and you are ready to get started!
      </p>
      <Button
        type="button"
        variant="primary"
        onClick={handleClose}
        className="button-base"
      >
        Confirm
      </Button>
    </div>
  );
};

export default TFAThirdStep;
